/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  ApiAction,
  BrandConfigurationResponseCollectionResponse,
  BrandConfigurationUpdateRequest,
  CalculationConfigurationDeleteRequest,
  CalculationConfigurationRequest,
  CalculationConfigurationResponseDataResponse,
  CalculationExperimentalConfigurationRequest,
  CalculationExperimentalConfigurationResponseCollectionResponse,
  CalculationStatusRequest,
  CalculationStatusResponseDataResponse,
  CalculationWithOverviewResponseCollectionResponse,
  CategoryFieldConfigurationResponseCollectionResponse,
  CategoryInsightsResponseDataResponse,
  CategorySkuCountResponseCollectionResponse,
  CategoryWarehouseOverviewResponseCollectionResponse,
  Condition,
  ConfigurationFieldType,
  ConfigurationRuleCreateRequest,
  ConfigurationRuleReplaceRequest,
  ConfigurationRuleResponseCollectionResponse,
  ConfigurationRuleResponseDataResponse,
  ConfigurationRuleSetupCreateRequest,
  ConfigurationRuleSetupDeleteRequest,
  ConfigurationRuleSetupUpdateRequest,
  ConfigurationRuleUpdateRequest,
  DeleteRegionFlowGroupConfigurationRequest,
  DeleteRegionFlowGroupRequest,
  DepartmentResponseCollectionResponse,
  ErrorResponse,
  FieldConfigurationDeleteRequest,
  FieldConfigurationRequest,
  ProductListConfigurationRequest,
  ProductListConfigurationResponseCollectionResponse,
  ProductListConfigurationResponseDataResponse,
  ProductListConfigurationUpdateRequest,
  RegionFlowGroupRequest,
  RegionFlowGroupResponseCollectionResponse,
  RegionFlowGroupResponseDataResponse,
  RegionResponseCollectionResponse,
  ScopeEntityConfigurationResponseCollectionResponse,
  SkuClassConfigurationRequest,
  SkuClassConfigurationResponseCollectionResponse,
  SkuClassConfigurationResponseDataResponse,
  Sorting,
  StoreResponseCollectionResponse,
  StoreScheduleExclusionResponseCollectionResponse,
  StoreScheduleExclusionUpdateRequest,
  StoreScheduleStoreExclusionResponseCollectionResponse,
  StoreTypeResponseCollectionResponse,
  TemplateRequest,
  TemplateUpdateRequest,
  TemplateWithRelatedResponseCollectionResponse,
  TemplateWithRelatedResponseDataResponse,
  ValidationArea,
  ValidationProblemResponseCollectionResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class Templates<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplates
   * @request GET:/Templates
   * @response `200` `TemplateWithRelatedResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplates = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TemplateWithRelatedResponseCollectionResponse, ErrorResponse>({
      path: `/Templates`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PostTemplate
   * @request POST:/Templates
   * @response `200` `TemplateWithRelatedResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTemplate = (data: TemplateRequest, params: RequestParams = {}) =>
    this.http.request<TemplateWithRelatedResponseDataResponse, ErrorResponse>({
      path: `/Templates`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplate
   * @request GET:/Templates/{id}
   * @response `200` `TemplateWithRelatedResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplate = (id: number, params: RequestParams = {}) =>
    this.http.request<TemplateWithRelatedResponseDataResponse, ErrorResponse>({
      path: `/Templates/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplate
   * @request PATCH:/Templates/{id}
   * @response `200` `TemplateWithRelatedResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplate = (id: number, data: TemplateUpdateRequest, params: RequestParams = {}) =>
    this.http.request<TemplateWithRelatedResponseDataResponse, ErrorResponse>({
      path: `/Templates/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplate
   * @request DELETE:/Templates/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplate = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name LoadFromCalculationTemplateConfiguration
   * @request POST:/Templates/{id}/LoadFromCalculation/{calculationId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  loadFromCalculationTemplateConfiguration = (
    id: number,
    calculationId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${id}/LoadFromCalculation/${calculationId}`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetAllOverlappingCalculations
   * @request GET:/Templates/OverlappingCalculations
   * @response `200` `CalculationWithOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getAllOverlappingCalculations = (params: RequestParams = {}) =>
    this.http.request<CalculationWithOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/OverlappingCalculations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateExperimentalConfigurations
   * @request GET:/Templates/{templateId}/ExperimentalConfigurations
   * @response `200` `CalculationExperimentalConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateExperimentalConfigurations = (templateId: number, params: RequestParams = {}) =>
    this.http.request<
      CalculationExperimentalConfigurationResponseCollectionResponse,
      ErrorResponse
    >({
      path: `/Templates/${templateId}/ExperimentalConfigurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplateExperimentalConfigurations
   * @request PATCH:/Templates/{templateId}/ExperimentalConfigurations
   * @response `200` `CalculationExperimentalConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplateExperimentalConfigurations = (
    templateId: number,
    data: CalculationExperimentalConfigurationRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<
      CalculationExperimentalConfigurationResponseCollectionResponse,
      ErrorResponse
    >({
      path: `/Templates/${templateId}/ExperimentalConfigurations`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateCalculationConfiguration
   * @summary Gets the Calculation Configuration of the specified template.
   * @request GET:/Templates/{id}/CalculationConfiguration
   * @response `200` `CalculationConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateCalculationConfiguration = (id: number, params: RequestParams = {}) =>
    this.http.request<CalculationConfigurationResponseDataResponse, ErrorResponse>({
      path: `/Templates/${id}/CalculationConfiguration`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplateCalculationConfiguration
   * @summary Updates the Calculation Configuration of the specified template. The configuration must not be locked. If the configuration is locked, only IsLocked property can be updated to unlock it.
   * @request PATCH:/Templates/{id}/CalculationConfiguration
   * @response `200` `CalculationConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplateCalculationConfiguration = (
    id: number,
    data: CalculationConfigurationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationConfigurationResponseDataResponse, ErrorResponse>({
      path: `/Templates/${id}/CalculationConfiguration`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name CalculationConfigurationDelete
   * @summary Deletes one of the SkuListConfigurationFlags from the Calculation Configuration of the specified template.
   * @request DELETE:/Templates/{id}/CalculationConfiguration
   * @response `200` `CalculationConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  calculationConfigurationDelete = (
    id: number,
    data: CalculationConfigurationDeleteRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationConfigurationResponseDataResponse, ErrorResponse>({
      path: `/Templates/${id}/CalculationConfiguration`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateConfigurationRules
   * @request GET:/Templates/{templateId}/ConfigurationRules
   * @response `200` `ConfigurationRuleResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateConfigurationRules = (templateId: number, params: RequestParams = {}) =>
    this.http.request<ConfigurationRuleResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PostTemplateConfigurationRule
   * @request POST:/Templates/{templateId}/ConfigurationRules
   * @response `200` `ConfigurationRuleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTemplateConfigurationRule = (
    templateId: number,
    data: ConfigurationRuleCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ConfigurationRuleResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateConfigurationRules
   * @request DELETE:/Templates/{templateId}/ConfigurationRules
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateConfigurationRules = (templateId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateScopeEntityConfigurations
   * @request GET:/Templates/{templateId}/ConfigurationRules/ScopeEntityConfigurations
   * @response `200` `ScopeEntityConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateScopeEntityConfigurations = (templateId: number, params: RequestParams = {}) =>
    this.http.request<ScopeEntityConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules/ScopeEntityConfigurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateConfigurationRule
   * @request GET:/Templates/{templateId}/ConfigurationRules/{id}
   * @response `200` `ConfigurationRuleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateConfigurationRule = (templateId: number, id: number, params: RequestParams = {}) =>
    this.http.request<ConfigurationRuleResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PutTemplateConfigurationRule
   * @request PUT:/Templates/{templateId}/ConfigurationRules/{id}
   * @response `200` `ConfigurationRuleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  putTemplateConfigurationRule = (
    templateId: number,
    id: number,
    data: ConfigurationRuleReplaceRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ConfigurationRuleResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplateConfigurationRule
   * @request PATCH:/Templates/{templateId}/ConfigurationRules/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplateConfigurationRule = (
    templateId: number,
    id: number,
    data: ConfigurationRuleUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateConfigurationRule
   * @request DELETE:/Templates/{templateId}/ConfigurationRules/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateConfigurationRule = (templateId: number, id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PostTemplateConfigurationRuleSetup
   * @request POST:/Templates/{templateId}/ConfigurationRules/{id}/Setups
   * @response `200` `ConfigurationRuleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTemplateConfigurationRuleSetup = (
    templateId: number,
    id: number,
    data: ConfigurationRuleSetupCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ConfigurationRuleResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules/${id}/Setups`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplateConfigurationRuleSetup
   * @request PATCH:/Templates/{templateId}/ConfigurationRules/{id}/Setups
   * @response `200` `ConfigurationRuleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplateConfigurationRuleSetup = (
    templateId: number,
    id: number,
    data: ConfigurationRuleSetupUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ConfigurationRuleResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules/${id}/Setups`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateConfigurationRuleSetup
   * @request DELETE:/Templates/{templateId}/ConfigurationRules/{id}/Setups
   * @response `200` `ConfigurationRuleResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateConfigurationRuleSetup = (
    templateId: number,
    id: number,
    data: ConfigurationRuleSetupDeleteRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ConfigurationRuleResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ConfigurationRules/${id}/Setups`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateStoreScheduleExclusions
   * @request GET:/Templates/{templateId}/StoreScheduleExclusions
   * @response `200` `StoreScheduleExclusionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateStoreScheduleExclusions = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreScheduleExclusionResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/StoreScheduleExclusions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateStoreScheduleExclusionsByStore
   * @request GET:/Templates/{templateId}/StoreScheduleExclusions/ByStore
   * @response `200` `StoreScheduleStoreExclusionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateStoreScheduleExclusionsByStore = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreScheduleStoreExclusionResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/StoreScheduleExclusions/ByStore`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PutTemplateStoreScheduleExclusion
   * @request PUT:/Templates/{templateId}/StoreScheduleExclusions/{storeScheduleId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  putTemplateStoreScheduleExclusion = (
    templateId: number,
    storeScheduleId: number,
    data: StoreScheduleExclusionUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/StoreScheduleExclusions/${storeScheduleId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateStores
   * @request GET:/Templates/{templateId}/Stores
   * @response `200` `StoreResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateStores = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Stores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateValidationProblems
   * @request GET:/Templates/{templateId}/ValidationProblems/{area}
   * @response `200` `ValidationProblemResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateValidationProblems = (
    templateId: number,
    area: ValidationArea,
    params: RequestParams = {},
  ) =>
    this.http.request<ValidationProblemResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ValidationProblems/${area}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateStoreTypes
   * @request GET:/Templates/{templateId}/StoreTypes
   * @response `200` `StoreTypeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateStoreTypes = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreTypeResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/StoreTypes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateDepartments
   * @request GET:/Templates/{templateId}/Departments
   * @response `200` `DepartmentResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateDepartments = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<DepartmentResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Departments`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateRegions
   * @request GET:/Templates/{templateId}/Regions
   * @response `200` `RegionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateRegions = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<RegionResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Regions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateConfiguration
   * @request GET:/Templates/{templateId}/Status
   * @response `200` `CalculationStatusResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateConfiguration = (templateId: number, params: RequestParams = {}) =>
    this.http.request<CalculationStatusResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Status`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplateConfiguration
   * @request PATCH:/Templates/{templateId}/Status
   * @response `200` `CalculationStatusResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplateConfiguration = (
    templateId: number,
    data: CalculationStatusRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatusResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Status`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateBrands
   * @request GET:/Templates/{templateId}/Brands
   * @response `200` `BrandConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateBrands = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BrandConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Brands`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PostTemplateBrandConfigurations
   * @request POST:/Templates/{templateId}/Brands/Configurations
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTemplateBrandConfigurations = (
    templateId: number,
    data: BrandConfigurationUpdateRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/Brands/Configurations`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateBrandConfigurations
   * @request DELETE:/Templates/{templateId}/Brands/Configurations
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateBrandConfigurations = (templateId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/Brands/Configurations`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PostTemplateBrandConfiguration
   * @request POST:/Templates/{templateId}/Brands/{id}/Configuration
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTemplateBrandConfiguration = (templateId: number, id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/Brands/${id}/Configuration`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateBrandConfiguration
   * @request DELETE:/Templates/{templateId}/Brands/{id}/Configuration
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateBrandConfiguration = (templateId: number, id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/Brands/${id}/Configuration`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateCategories
   * @request GET:/Templates/{templateId}/Categories
   * @response `200` `CategorySkuCountResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateCategories = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CategorySkuCountResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Categories`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateDeviations
   * @request GET:/Templates/{templateId}/Categories/Deviations
   * @response `200` `CategoryFieldConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateDeviations = (templateId: number, params: RequestParams = {}) =>
    this.http.request<CategoryFieldConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Categories/Deviations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateCategoryConfigurations
   * @request GET:/Templates/{templateId}/Categories/{categoryId}/Configurations
   * @response `200` `CategoryFieldConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateCategoryConfigurations = (
    templateId: number,
    categoryId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryFieldConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Categories/${categoryId}/Configurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplateCategoryConfiguration
   * @request PATCH:/Templates/{templateId}/Categories/{categoryId}/Configurations
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplateCategoryConfiguration = (
    templateId: number,
    categoryId: number,
    data: FieldConfigurationRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/Categories/${categoryId}/Configurations`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateCategoryConfigurations
   * @request DELETE:/Templates/{templateId}/Categories/{categoryId}/Configurations
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateCategoryConfigurations = (
    templateId: number,
    categoryId: number,
    data: FieldConfigurationDeleteRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/Categories/${categoryId}/Configurations`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateCategoryEntityListConfigurations
   * @request DELETE:/Templates/{templateId}/Categories/{categoryId}/EntityLists/{entityListId}/ConfigurationFieldType/{configurationFieldType}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateCategoryEntityListConfigurations = (
    templateId: number,
    categoryId: number,
    entityListId: number,
    configurationFieldType: ConfigurationFieldType,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/Categories/${categoryId}/EntityLists/${entityListId}/ConfigurationFieldType/${configurationFieldType}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateCategoryDeviationsApiAction
   * @request DELETE:/Templates/{templateId}/Categories/{categoryId}/Deviations/ApiAction/{apiAction}
   * @response `200` `CategoryFieldConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateCategoryDeviationsApiAction = (
    templateId: number,
    categoryId: number,
    apiAction: ApiAction,
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryFieldConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Categories/${categoryId}/Deviations/ApiAction/${apiAction}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateCategoryInsights
   * @request GET:/Templates/{templateId}/Categories/{categoryId}/Insights
   * @response `200` `CategoryInsightsResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateCategoryInsights = (
    templateId: number,
    categoryId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryInsightsResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Categories/${categoryId}/Insights`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateCategoryWarehouseOverview
   * @request GET:/Templates/{templateId}/Categories/{categoryId}/WarehouseOverviews
   * @response `200` `CategoryWarehouseOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateCategoryWarehouseOverview = (
    templateId: number,
    categoryId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryWarehouseOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/Categories/${categoryId}/WarehouseOverviews`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateProductListConfigurations
   * @request GET:/Templates/{templateId}/ProductLists/Configurations
   * @response `200` `ProductListConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateProductListConfigurations = (
    templateId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProductListConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ProductLists/Configurations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateProductListConfigurations
   * @request DELETE:/Templates/{templateId}/ProductLists/Configurations
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateProductListConfigurations = (templateId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/ProductLists/Configurations`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PostTemplateProductListConfiguration
   * @request POST:/Templates/{templateId}/ProductLists/{id}/Configurations
   * @response `200` `ProductListConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTemplateProductListConfiguration = (
    templateId: number,
    id: number,
    data: ProductListConfigurationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ProductListConfigurationResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ProductLists/${id}/Configurations`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplateProductListConfiguration
   * @request PATCH:/Templates/{templateId}/ProductLists/{id}/Configurations
   * @response `200` `ProductListConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplateProductListConfiguration = (
    templateId: number,
    id: number,
    data: ProductListConfigurationUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ProductListConfigurationResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/ProductLists/${id}/Configurations`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateProductListConfiguration
   * @request DELETE:/Templates/{templateId}/ProductLists/{id}/Configurations
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateProductListConfiguration = (
    templateId: number,
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/ProductLists/${id}/Configurations`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateRegionFlowGroups
   * @request GET:/Templates/{templateId}/RegionFlowGroups
   * @response `200` `RegionFlowGroupResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateRegionFlowGroups = (templateId: number, params: RequestParams = {}) =>
    this.http.request<RegionFlowGroupResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/RegionFlowGroups`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PostTemplateRegionFlowGroup
   * @request POST:/Templates/{templateId}/RegionFlowGroups
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTemplateRegionFlowGroup = (templateId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/RegionFlowGroups`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateRegionFlowGroup
   * @request DELETE:/Templates/{templateId}/RegionFlowGroups
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateRegionFlowGroup = (
    templateId: number,
    data: DeleteRegionFlowGroupRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/RegionFlowGroups`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateRegionFlowGroup
   * @request GET:/Templates/{templateId}/RegionFlowGroups/{id}
   * @response `200` `RegionFlowGroupResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateRegionFlowGroup = (templateId: number, id: number, params: RequestParams = {}) =>
    this.http.request<RegionFlowGroupResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/RegionFlowGroups/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PostTemplateRegionFlowGroupConfiguration
   * @request POST:/Templates/{templateId}/RegionFlowGroups/{id}/Configuration
   * @response `200` `RegionFlowGroupResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTemplateRegionFlowGroupConfiguration = (
    templateId: number,
    id: number,
    data: RegionFlowGroupRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<RegionFlowGroupResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/RegionFlowGroups/${id}/Configuration`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name DeleteTemplateRegionFlowConfiguration
   * @request DELETE:/Templates/{templateId}/RegionFlowGroups/{id}/Configuration
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTemplateRegionFlowConfiguration = (
    templateId: number,
    id: number,
    data: DeleteRegionFlowGroupConfigurationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Templates/${templateId}/RegionFlowGroups/${id}/Configuration`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name GetTemplateSkuClassConfigurations
   * @request GET:/Templates/{templateId}/SkuClasses/Configurations
   * @response `200` `SkuClassConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getTemplateSkuClassConfigurations = (templateId: number, params: RequestParams = {}) =>
    this.http.request<SkuClassConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Templates/${templateId}/SkuClasses/Configurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Templates
   * @name PatchTemplateSkuClassConfigurations
   * @request PATCH:/Templates/{templateId}/SkuClasses/{skuClassId}/Configurations
   * @response `200` `SkuClassConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchTemplateSkuClassConfigurations = (
    templateId: number,
    skuClassId: number,
    data: SkuClassConfigurationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SkuClassConfigurationResponseDataResponse, ErrorResponse>({
      path: `/Templates/${templateId}/SkuClasses/${skuClassId}/Configurations`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
